import { render, staticRenderFns } from "./INSTANCIA_ODT.vue?vue&type=template&id=0afc3b00&scoped=true&"
import script from "./INSTANCIA_ODT.vue?vue&type=script&lang=js&"
export * from "./INSTANCIA_ODT.vue?vue&type=script&lang=js&"
import style0 from "./INSTANCIA_ODT.vue?vue&type=style&index=0&id=0afc3b00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afc3b00",
  null
  
)

export default component.exports